<template>
  <span class="exportBtn">
    <lk-button :type="type"  :icon="icon" :loading='loading' @click="click">
        <span v-if="!loading">{{text}}</span>
        <span v-else>导出中</span>
    </lk-button>
  </span>
</template>
<script>
import report from '../../services/report';
import utils from '../../libs/utils';

export default {
  name: 'exportAsync',
  props: {
    text: {
      type: String,
      default: '导出Excel',
    },
    type: {
      type: String,
      default: 'primary',
    },
    icon: {
      type: String,
      default: 'md-add',
    },
    id: {
      type: String,
    },


  },
  data() {
    return {
      loading: false,


    };
  },
  // watch: {
  //   $route: {
  //     handler() {
  //       this.break = true;
  //     },
  //     deep: true,
  //   },
  // },
  methods: {
    click() { // 异步回调
      this.$emit('on-click', { id: this.id, text: this.text }, (data) => {
        // if (res.data.status === 200) {
        this.loading = true;

        this.checkLoading(data.id);
        // }
      });
    },
    checkLoading(id) {
      this.$store.commit('setDisableLoading', true);
      report.getReportFile({ id }).then((res) => {
        const { data } = res.data;
        if (res.data.status === 200) {
          if (data.status === 1) {
            const name = this.$route.name;
            setTimeout(() => {
              console.log(name);

              if (name === this.$route.name) {
                this.checkLoading(id);
              } else {
                this.loading = false;
              }
              // 保存路由解决跳转路由还会继续递归调用问题
            }, 5000);
          } else if (data.status === 2) {
            this.exprotEnd(id, data.fileName);
          } else if (data.status === 3) {
            this.$Message.error('文件已失效');
            this.loading = false;
          }
          // switch (data.status) {
          //   case 1: () => {

          //   };
          //     break;
          //   case 2:

          //     break;
          //   case 3: () => {

          //   };
          //     break;

          //   default:
          //     break;
          // }
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        this.loading = false;
        console.log(err);
        utils.handleError(err);
      });
    },
    exprotEnd(id, fileName) {
      this.$store.commit('setDisableLoading', true);

      report.downloadReportFile({ id }).then((res) => { // 暂不修改
        if (res.data.error) {
          this.$Message.error(res.data.error);
        } else {
          const isEXCLE = res.headers['content-type'] === 'application/vnd.ms-excel;charset=GBK';
          if (!isEXCLE) {
            utils.blobResponseToJson(res).then((errorMsg) => {
              this.$Message.error(errorMsg.error);
            });
          } else {
            utils.downFile(res.data, fileName || 'InventoryReport_Goods.xlsx', res.data.type);
          }
        }
        // this.$Message.success('下载成功！');
        this.loading = false;
      }).catch((err) => {
        console.log(err);
        utils.handleError(err);
      });
    },
  },

};
</script>
<style lang="less" scoped>
.exportBtn{
  display: inline-block;
  // margin-bottom: 12px
}
</style>
